import React, { useState, useEffect } from 'react';
// import ImageGallery from 'react-image-gallery';
// import 'react-image-gallery/styles/css/image-gallery.css'; // Import the CSS for styling
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';

const MyImageGallery = (props, title) => {
  /*
  const images = [
    {
      original: 'https://picsum.photos/id/1018/1000/600/',
      thumbnail: 'https://picsum.photos/id/1018/250/150/',
    },
    {
      original: 'https://picsum.photos/id/1015/1000/600/',
      thumbnail: 'https://picsum.photos/id/1015/250/150/',
    },
    {
      original: 'https://picsum.photos/id/1019/1000/600/',
      thumbnail: 'https://picsum.photos/id/1019/250/150/',
    },
  ];
  console.log(props.items.length, 'props');
 */
  return (
    <>
      {/* <ImageGallery
        // items={props.items}
        items={images}
        thumbnailPosition={'left'}
        showFullscreenButton={false}
        showPlayButton={false}
        originalWidth={'100%'}
      /> */}
      {props.items.length != 1 ? (
        <Carousel showBullets={'false'}>
          {props.items.map((image, index) => (
            <div key={index}>
              <img src={image.original} alt={`Image ${index + 1}`} />
            </div>
          ))}
        </Carousel>
      ) : (
        <img
          src={
            props.items[0].original === undefined
              ? props.items[0].original
              : props.items[0].original
          }
          // Ensure HTML encoded entities display properly
          alt={title}
          className="xrs-product__image"
          width="170px"
          height="170px"
        />
      )}
    </>
  );
};

export default MyImageGallery;
